/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { TaskSubmissionVersionDetail } from './taskSubmissionVersionDetail';

export type GenericApiResponseTaskSubmissionVersionDetailData = TaskSubmissionVersionDetail | null;
